import { translate } from "../../config/localisation";
import { Typography } from "@mui/material"

// project_stage — это НЕ текущий этап работы над проектом, а его настройка:
// какие этапы проверки в нём включены. Подписи «Разметка / Проверка /
// Суперпроверка» читались как «проект сейчас на проверке», хотя проект в
// работе постоянно, и задачи в нём одновременно на разных этапах.
// Поле name оставлено английским — на него завязана логика в других местах.

const chip = (bg, color, key) => (
    <Typography
        variant="caption"
        sx={{ p: 1, backgroundColor: bg, color, borderRadius: 2, fontWeight: 600 }}
    >
        {translate(key)}
    </Typography>
);

const UserMappedByProjectStage = (roleId) => {
    if(roleId == 1){
        return {id: roleId, name : "Annotation", element : chip("rgb(34, 134, 202 ,0.2)", "rgb(34, 134, 202 )", "stage.annotationOnly")}
    } else if(roleId == 2){
        return {id: roleId, name : "Review", element : chip("rgb(230, 126, 34  ,0.2)", "rgb(230, 126, 34   )", "stage.reviewEnabled")}
    } else if(roleId == 3){
        return {id: roleId, name : "Supercheck", element : chip("rgb(142, 68, 173,0.2)", "rgb(142, 68, 173 )", "stage.supercheckEnabled")}
    }

}

export default UserMappedByProjectStage;
